//mypreset.ts
import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';



const DefaultPreset = definePreset(Aura, {


  semantic: {
    primary:{
          50: '#E8F1F3',
          100:'#D8E7EB',
          200:'#B9D4DC',
          300:'#9AC1CC',
          400:'#7BAEBC',
          500:'#3D889D',
          600:'#36788A',
          700:'#2E6777',
          800:'#275764',
          900:'#204752',
          950:'#1B3C45  ',
    },
    colorScheme :{
     light: {
            surface: {
              0:  '#ffffff',
      50: '#f3f4f6',
      100:'#e6edf2',
      200:'#d6e3ea',
      300:'#c3d6df',
      400:'#afc6d0',
      500:'#97b0bb',
      600:'#7f99a5',
      700:'#687f8b',
      800:'#526671',
      900:'#3e5059',
      950:'#303f46'
            },
        },
       text: {
                color: '#000000',
                hoverColor: '#000000',
                mutedColor: '#000000',
                hoverMutedColor: '#000000'
            },
              formField: {
                color : '#000000',
                placeholderColor: '{gray.400}',

            },
    // primary: {
    //   50: '{indigo.50}',
    //   100: '{indigo.100}',
    //   200: '{indigo.200}',
    //   300: '{indigo.300}',
    //   400: '{indigo.400}',
    //   500: '{indigo.500}',
    //   600: '{indigo.600}',
    //   700: '{indigo.700}',
    //   800: '{indigo.800}',
    //   900: '{indigo.900}',
    //   950: '{indigo.950}',
    // },
  }}
});

export { DefaultPreset };
